import { newAmount } from '@orus.eu/amount'

import { createPolicyItemConfigurationResolver } from '../../../model/policy-item-configuration.ts'
import type { PolicyItems } from '../../../model/policy-item.ts'
import type { FrRcpaxePolicyItem, FrRcpaxePolicyItemsState } from '../fr-rcpaxe-insurance.ts'

// The limits and deductibles are fr-rcpw's, as settled with Axeria.
export const frRcpaxePolicyItems_v1_0_0 = {
  proLiability: {
    name: 'proLiability',
    type: 'guarantee',
    optionality: ['included'],
    possibleLimitOfIndemnities: {
      type: 'amounts',
      amounts: [
        newAmount(50_000),
        newAmount(100_000),
        newAmount(200_000),
        newAmount(300_000),
        newAmount(400_000),
        newAmount(500_000),
        newAmount(750_000),
        newAmount(1_000_000),
        newAmount(1_500_000),
        newAmount(2_000_000),
        newAmount(3_000_000),
      ],
    },
    possibleDeductibles: {
      type: 'calculatedAmount',
    },
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: false,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: true,
        canBeSelected: false,
      }),
    }),
    additionalInfo: null,
    dependsOn: [],
  },
  publicLiability: {
    name: 'publicLiability',
    type: 'guarantee',
    optionality: ['optional'],
    possibleLimitOfIndemnities: {
      type: 'fixedAmount',
      amount: newAmount(5_000_000),
    },
    possibleDeductibles: {
      type: 'calculatedAmount',
    },
    editConfiguration: createPolicyItemConfigurationResolver({
      selfOnboardingConfiguration: () => ({
        isHidden: false,
        canBeUpdated: false,
        canBeSelected: true,
      }),
      backofficeConfiguration: () => ({
        isHidden: false,
        canBeUpdated: false,
        canBeSelected: true,
      }),
    }),
    additionalInfo: null,
    dependsOn: [],
  },
} as const satisfies PolicyItems<FrRcpaxePolicyItem, FrRcpaxePolicyItemsState>
